/* Skillet Cookie Company design layer (AdBreakers, Oct 2026): bundle offers, video tiles, strips, anchors. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  var ARROW =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16M14 6l6 6-6 6"/></svg>';

  function initOffer(offer) {
    if (offer.getAttribute('data-on')) return;
    offer.setAttribute('data-on', '1');
    var info = offer.closest('.product__info-container') || document;
    if (info.classList) info.classList.add('scc-has-offer');
    var tiers = [].slice.call(offer.querySelectorAll('[data-scc-tier]'));
    if (!tiers.length) return;

    var formId = offer.getAttribute('data-form');
    var form = document.getElementById(formId);
    var qty = document.querySelector('input[name="quantity"][form="' + formId + '"]') || (form && form.querySelector('input[name="quantity"]'));
    if (!qty && form) {
      qty = document.createElement('input');
      qty.type = 'hidden';
      qty.name = 'quantity';
      form.appendChild(qty);
    }

    // The price pill lives inside the Add to cart button. Apps (the flavour picker) rebuild that button after
    // load, so the pill is looked up on every change instead of being kept from the first render.
    var current = null;
    function paintPill() {
      var btn = info.querySelector ? info.querySelector('.product-form__submit') : null;
      if (!btn || !current) return;
      var pill = btn.querySelector('.scc-atc__pill');
      if (!pill) {
        pill = document.createElement('span');
        pill.className = 'scc-atc__pill';
        pill.innerHTML = '<s></s><b></b>';
        btn.appendChild(pill);
      }
      if (!btn.querySelector('.scc-atc__arrow')) {
        var arr = document.createElement('span');
        arr.className = 'scc-atc__arrow';
        arr.innerHTML = ARROW;
        btn.appendChild(arr);
      }
      var was = current.dataset.was || '', now = current.dataset.now || '';
      var s = pill.querySelector('s'), b = pill.querySelector('b');
      if (s && s.textContent !== was) s.textContent = was;
      if (b && b.textContent !== now) b.textContent = now;
    }

    var now = offer.querySelector('[data-scc-now]');
    var was = offer.querySelector('[data-scc-was]');
    var save = offer.querySelector('[data-scc-save]');
    var perkPct = offer.querySelector('[data-scc-perk="pct"]');
    var perkShip = offer.querySelector('[data-scc-perk="ship"]');
    var perkGift = offer.querySelector('[data-scc-perk="gift"]');

    function apply(tier) {
      var d = tier.dataset;
      tiers.forEach(function (t) {
        t.classList.toggle('is-on', t === tier);
      });
      if (now) now.textContent = d.now;
      if (was) was.textContent = d.was || '';
      if (save) {
        save.textContent = d.save || '';
        save.hidden = !d.save;
      }
      if (qty) {
        qty.value = d.qty;
        if (qty.type !== 'hidden') qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      current = tier;
      paintPill();
      if (perkPct) {
        var on = parseInt(d.pct, 10) > 0;
        var t = perkPct.querySelector('.scc-perk__t');
        perkPct.classList.toggle('is-on', on);
        t.textContent = on ? t.getAttribute('data-on-tpl').replace('[pct]', d.pct) : t.getAttribute('data-off');
        perkPct.querySelector('[data-scc-perk-save]').textContent = on ? d.save : perkPct.getAttribute('data-locked-sub') || '';
      }
      if (perkShip) {
        var ship = d.ship === '1';
        var ts = perkShip.querySelector('.scc-perk__t');
        perkShip.classList.toggle('is-on', ship);
        ts.textContent = ship ? ts.getAttribute('data-on') : ts.getAttribute('data-off');
      }
      if (perkGift) {
        var gift = d.gift === '1';
        var tg = perkGift.querySelector('.scc-perk__t');
        perkGift.classList.toggle('is-on', gift);
        tg.textContent = gift ? tg.getAttribute('data-on') : tg.getAttribute('data-off');
      }
    }

    tiers.forEach(function (t) {
      t.querySelector('input').addEventListener('change', function () {
        apply(t);
      });
    });
    var start =
      tiers.filter(function (t) {
        return t.querySelector('input').checked;
      })[0] || tiers[0];
    start.querySelector('input').checked = true;
    apply(start);
    if (window.MutationObserver && info.nodeType === 1) {
      var wait = null;
      new MutationObserver(function () {
        clearTimeout(wait);
        wait = setTimeout(paintPill, 60);
      }).observe(info, { childList: true, subtree: true });
    }
  }

  function initVideos(root) {
    if (root.getAttribute('data-on')) return;
    root.setAttribute('data-on', '1');
    var tiles = [].slice.call(root.querySelectorAll('.scc-vids__tile'));
    tiles.forEach(function (tile) {
      var v = tile.querySelector('video');
      var b = tile.querySelector('.scc-vids__play');
      function stop() {
        v.pause();
        tile.classList.remove('is-playing');
      }
      b.addEventListener('click', function () {
        document.querySelectorAll('.scc-vids__tile.is-playing video').forEach(function (o) {
          o.pause();
          o.closest('.scc-vids__tile').classList.remove('is-playing');
        });
        tile.classList.add('is-playing');
        v.play().catch(function () {
          tile.classList.remove('is-playing');
        });
      });
      v.addEventListener('click', stop);
    });
  }

  function initCountdown(el) {
    if (el.getAttribute('data-on')) return;
    el.setAttribute('data-on', '1');
    var end = new Date(el.getAttribute('data-end')).getTime();
    var live = el.querySelector('[data-scc-cd-live]');
    var fallback = el.querySelector('[data-scc-cd-fallback]');
    var d = el.querySelector('[data-scc-cd-d]'), h = el.querySelector('[data-scc-cd-h]'), m = el.querySelector('[data-scc-cd-m]'), s = el.querySelector('[data-scc-cd-s]');
    function p(n) { return (n < 10 ? '0' : '') + n; }
    function over() { if (live) live.style.display = 'none'; if (fallback) fallback.hidden = false; el.classList.add('is-over'); }
    if (!live || isNaN(end)) { over(); return; }
    (function tick() {
      var left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) { over(); return; }
      var days = Math.floor(left / 86400), hrs = Math.floor((left % 86400) / 3600);
      if (d) d.textContent = p(days); else hrs += days * 24;
      h.textContent = p(hrs); m.textContent = p(Math.floor((left % 3600) / 60)); s.textContent = p(left % 60);
      setTimeout(tick, 1000);
    })();
  }

  ready(function () {
    document.querySelectorAll('[data-scc-cd][data-end]').forEach(initCountdown);
    document.querySelectorAll('[data-scc-offer]').forEach(initOffer);
    document.querySelectorAll('[data-scc-vids]').forEach(initVideos);

    document.addEventListener('click', function (e) {
      var nav = e.target.closest('[data-scc-prev],[data-scc-next]');
      if (nav) {
        var host = nav.closest('.scc-nav').parentNode;
        var strip = host.querySelector('[data-scc-strip]');
        if (strip && strip.firstElementChild) {
          var step = strip.firstElementChild.getBoundingClientRect().width + 14;
          var dir = nav.hasAttribute('data-scc-next') ? 1 : -1;
          strip.scrollBy({ left: dir * step * (window.innerWidth < 750 ? 1 : 2), behavior: 'smooth' });
        }
        return;
      }
      var a = e.target.closest('a[href="#scc-buy"]');
      if (a) {
        var target = document.querySelector('.product__info-wrapper') || document.querySelector('[data-scc-offer]');
        if (target) {
          e.preventDefault();
          var y = target.getBoundingClientRect().top + window.pageYOffset - 90;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    });

    /* one open row at a time inside the same accordion group */
    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d.open || !d.classList || !d.classList.contains('scc-tile')) return;
        d.parentNode.querySelectorAll('.scc-tile[open]').forEach(function (o) {
          if (o !== d) o.open = false;
        });
      },
      true
    );
  });

  /* theme editor: re-init when a section is re-rendered */
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-scc-offer]').forEach(initOffer);
    e.target.querySelectorAll('[data-scc-vids]').forEach(initVideos);
  });
})();
